import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "admin-layout" }
const _hoisted_2 = { class: "admin-sidebar" }
const _hoisted_3 = { class: "admin-content" }

import MainLayout from './MainLayout.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'AdminLayout',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(MainLayout, { showStatsSidebar: false }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_v_card, {
            elevation: "2",
            class: "sidebar-card"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_list, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_list_item, {
                    to: "/admin/general",
                    active: _ctx.$route.path === '/admin/general',
                    color: "primary"
                  }, {
                    prepend: _withCtx(() => [
                      _createVNode(_component_v_icon, { icon: "mdi-cog" })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_title, null, {
                        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                          _createTextVNode("General", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["active"]),
                  _createVNode(_component_v_list_item, {
                    to: "/admin/people",
                    active: _ctx.$route.path === '/admin/people',
                    color: "primary"
                  }, {
                    prepend: _withCtx(() => [
                      _createVNode(_component_v_icon, { icon: "mdi-account-group" })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_title, null, {
                        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                          _createTextVNode("People", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["active"]),
                  _createVNode(_component_v_list_item, {
                    to: "/admin/rewards",
                    active: _ctx.$route.path === '/admin/rewards',
                    color: "primary"
                  }, {
                    prepend: _withCtx(() => [
                      _createVNode(_component_v_icon, { icon: "mdi-gift" })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_title, null, {
                        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                          _createTextVNode("Rewards", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["active"]),
                  _createVNode(_component_v_list_item, {
                    to: "/admin/redemptions",
                    active: _ctx.$route.path === '/admin/redemptions',
                    color: "primary"
                  }, {
                    prepend: _withCtx(() => [
                      _createVNode(_component_v_icon, { icon: "mdi-gift-outline" })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_v_list_item_title, null, {
                        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                          _createTextVNode("Redemptions", -1)
                        ]))]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["active"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ])
    ]),
    _: 3
  }))
}
}

})